import React from 'react';

const SensorSelectContext = React.createContext(3);
export const SensorSelectContextProvider = SensorSelectContext.Provider;
export default SensorSelectContext;
